import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
const failures = ['Los cursos largos de programación no sirven cuando tenés que pagar las cuentas HOY mismo.', 'El trading requiere un capital que no podés permitirte perder en una aplicación.', 'Las plataformas de encuestas están diseñadas para que pierdas horas a cambio de migajas.', 'Buscar trabajo remoto tradicional es imposible si no hablás un inglés perfecto (hasta ahora).'];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function FailedSolutions() {
  return <section className="py-20 px-4" data-id="element-23">
      <div className="max-w-4xl mx-auto" data-id="element-24">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-25">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-26">
            Por qué lo que intentaste{' '}
            <span className="text-red-400" data-id="element-27">no funcionó</span>
          </h2>
          <div className="w-24 h-1 bg-red-500/50 mx-auto rounded-full" data-id="element-28" />
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-29">
          {failures.map((text, index) => <motion.div key={index} variants={itemVariants} className="bg-[#0a0f1a] border border-red-900/30 p-6 rounded-xl flex items-start gap-4 hover:border-red-500/30 transition-colors" data-id="element-30">
              <div className="bg-red-500/10 p-2 rounded-full shrink-0 mt-1" data-id="element-31">
                <X className="w-6 h-6 text-red-500" data-id="element-32" />
              </div>
              <p className="text-gray-300 leading-relaxed" data-id="element-33">{text}</p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}